import React from "react";
import { useImageUpload } from "frontend/src/lib/use-image-upload";
export var useCreatePlaylistBusinessTypeForm = function (initial) {
    var _a = React.useState(initial.title), title = _a[0], setTitle = _a[1];
    var _b = useImageUpload({
        file: null,
        image: initial.image,
    }), image = _b.image, onImageChange = _b.onImageChange, resetImage = _b.resetImage, setImage = _b.setImage, file = _b.file;
    var _c = React.useState({}), errors = _c[0], setErrors = _c[1];
    var validate = function () {
        var errorBag = {};
        if (title.length === 0) {
            errorBag.title = "Введите название.";
        }
        if (file === null) {
            errorBag.image = "Выберите изображение.";
        }
        if (file === null || title.length === 0) {
            setErrors(errorBag);
            return { type: "error" };
        }
        setErrors({});
        return { type: "success", validated: { title: title, file: file } };
    };
    var onTitleChange = function (evt) {
        return setTitle(evt.target.value);
    };
    return {
        title: {
            value: title,
            set: setTitle,
            error: errors.title,
            onChange: onTitleChange,
        },
        image: {
            value: image,
            set: setImage,
            onChange: onImageChange,
            reset: resetImage,
            error: errors.image,
        },
        validate: validate,
    };
};
